// RemovableLogs.tsx
import HwzComponent from '../../../common/component/HwzComponent';
import { RouteComponentProps } from 'react-router-dom';
import Pager from '../../../common/model/base/Pager';
import Lang from '../../../common/model/global/Lang';
import { 
  Button, 
  Table, 
  Tag, 
  Tooltip, 
  Card,
  Row,
  Col,
  Input,
  Select,
  DatePicker,
  Space as AntdSpace
} from 'antd';
import React from 'react';
import TableEmpty from '../../widget/TableEmpty';
import { ColumnsType } from 'antd/es/table';
import {
  HistoryOutlined,
  SearchOutlined,
  ReloadOutlined
} from '@ant-design/icons';
import moment, { Moment } from 'moment';

// 导入修正后的模型
import RemovableOperationLog from '../../../common/model/removable/RemovableOperationLog';

const { RangePicker } = DatePicker;

interface IProps extends RouteComponentProps {}

interface IState {
  searchKeyword: string;
  filterOperation: string | null;
  filterSuccess: boolean | null;
  dateRange: [Moment, Moment] | null;
}

export default class RemovableLogs extends HwzComponent<IProps, IState> {
  pager: Pager<RemovableOperationLog>;

  constructor(props: IProps) {
    super(props);
    
    this.state = {
      searchKeyword: '',
      filterOperation: null,
      filterSuccess: null,
      dateRange: null
    };
    
    // 创建Pager实例 - 使用正确的模型
    this.pager = new Pager<RemovableOperationLog>(this, RemovableOperationLog, 20);
    
    console.log('Pager初始化，URL:', this.pager.urlPage);
  }

  componentDidMount() {
    console.log('组件挂载，Pager URL:', this.pager.urlPage);
    this.pager.enableHistory();
    this.refresh();
  }

  refresh = () => {
    this.applyFilters();
  }

  // 应用过滤器
  applyFilters = () => {
    const { searchKeyword, filterOperation, filterSuccess, dateRange } = this.state;
    
    console.log('应用过滤器，当前URL:', this.pager.urlPage);
    
    // 重置到第一页
    this.pager.page = 0;
    
    // 设置过滤器值
    this.pager.resetFilter();
    
    if (searchKeyword) {
      this.pager.setFilterValue('keyword', searchKeyword);
    }
    
    if (filterOperation) {
      this.pager.setFilterValue('operation', filterOperation);
    }
    
    if (filterSuccess !== null) {
      this.pager.setFilterValue('success', filterSuccess.toString());
    }
    
    if (dateRange && dateRange[0] && dateRange[1]) {
      const startTime = dateRange[0].format('YYYY-MM-DD HH:mm:ss');
      const endTime = dateRange[1].format('YYYY-MM-DD HH:mm:ss');
      this.pager.setFilterValue('startTime', startTime);
      this.pager.setFilterValue('endTime', endTime);
    }
    
    // 调用Pager的httpList方法
    this.pager.httpList();
  }

  // 重置过滤器
  handleResetFilters = () => {
    this.setState({
      searchKeyword: '',
      filterOperation: null,
      filterSuccess: null,
      dateRange: null
    }, () => {
      this.pager.resetFilter();
      this.pager.page = 0;
      this.pager.httpList();
    });
  }

  // 处理日期范围选择
  handleDateRangeChange = (dates: [Moment | null, Moment | null] | null) => {
    if (!dates) {
      this.setState({ dateRange: null });
      return;
    }
    
    const [start, end] = dates;
    if (start && end) {
      this.setState({ dateRange: [start, end] });
    } else {
      this.setState({ dateRange: null });
    }
  };

  // 渲染搜索工具栏
  renderSearchToolbar = () => {
    const { searchKeyword, filterOperation, filterSuccess, dateRange } = this.state;
    
    const operationOptions = [
      { value: null, label: Lang.t('common.all') },
      { value: 'LIST_DEVICES', label: Lang.t('removable.opListDevices') },
      { value: 'BROWSE', label: Lang.t('removable.opBrowse') },
      { value: 'DOWNLOAD', label: Lang.t('removable.opDownload') },
      { value: 'PREVIEW', label: Lang.t('removable.opPreview') },
      { value: 'RENAME', label: Lang.t('removable.opRename') },
      { value: 'UPLOAD', label: Lang.t('removable.opUpload') },
      { value: 'UPUPLOAD_FOLDER', label: Lang.t('removable.opUpload') },
      { value: 'DELETE', label: Lang.t('removable.opDelete') },
      { value: 'MKDIR', label: Lang.t('log.createDirectory') },
    ];
    
    const successOptions = [
      { value: null, label: Lang.t('common.all') },
      { value: 'true', label: Lang.t('common.success') },
      { value: 'false', label: Lang.t('space.failed') },
    ];

    return (
      <Card size="small" style={{ marginBottom: 16 }}>
        <Row gutter={[16, 16]} align="middle">
          <Col xs={24} sm={12} md={6}>
            <div>
              <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>
                {Lang.t('common.search')}
              </div>
              <Input
                placeholder={Lang.t('removable.searchLogs')}
                value={searchKeyword}
                onChange={(e) => this.setState({ searchKeyword: e.target.value })}
                allowClear
                prefix={<SearchOutlined />}
                onPressEnter={this.applyFilters}
              />
            </div>
          </Col>
          
          <Col xs={24} sm={12} md={6}>
            <div>
              <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>
                {Lang.t('removable.filterByOperation')}
              </div>
              <Select
                value={filterOperation}
                onChange={(value) => this.setState({ filterOperation: value })}
                placeholder={Lang.t('removable.selectOperation')}
                style={{ width: '100%' }}
                allowClear
              >
                {operationOptions.map(option => (
                  <Select.Option key={option.value || 'all'} value={option.value}>
                    {option.label}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </Col>
          
          <Col xs={24} sm={12} md={6}>
            <div>
              <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>
                {Lang.t('removable.filterByStatus')}
              </div>
              <Select
                value={filterSuccess}
                onChange={(value) => this.setState({ filterSuccess: value })}
                placeholder={Lang.t('removable.selectStatus')}
                style={{ width: '100%' }}
                allowClear
              >
                {successOptions.map(option => (
                  <Select.Option key={option.value || 'all'} value={option.value}>
                    {option.label}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </Col>
          
          <Col xs={24} sm={12} md={6}>
            <div>
              <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>
                {Lang.t('removable.filterByTime')}
              </div>
              <RangePicker
                style={{ width: '100%' }}
                value={dateRange || undefined}
                onChange={this.handleDateRangeChange}
                showTime
                allowClear
                // 添加这行，从您的Lang模块获取国际化文本
                placeholder={[
                  Lang.t('common.startDate', '开始时间'),
                  Lang.t('common.endDate', '结束时间')
                ]}
              />
            </div>
          </Col>
          
          <Col xs={24} style={{ textAlign: 'right' }}>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <Button
                type="default"
                icon={<ReloadOutlined />}
                onClick={this.handleResetFilters}
              >
                {Lang.t('common.reset')}
              </Button>
              <Button
                type="primary"
                icon={<SearchOutlined />}
                onClick={this.applyFilters}
                loading={this.pager.loading}
              >
                {Lang.t('common.search')}
              </Button>
            </div>
          </Col>
        </Row>
      </Card>
    );
  }

  render() {
    const columns: ColumnsType<RemovableOperationLog> = [
      {
        title: Lang.t('removable.operationTime'),
        dataIndex: 'createTime',
        width: 180,
        sorter: true,
        sortOrder: this.pager.getDefaultSortOrder('createTime'),
        sortDirections: ['descend', 'ascend'],
        render: (createTime: Date, log: RemovableOperationLog) => (
          <div>
            <div>{log.getFormattedTime()}</div>
            <div style={{ fontSize: 12, color: '#666' }}>
              {log.clientIp || '--'}
            </div>
          </div>
        ),
      },
      {
        title: Lang.t('removable.user'),
        dataIndex: 'username',
        width: 120,
        render: (username: string) => (
          <div style={{ fontWeight: 'bold' }}>{username}</div>
        ),
      },
      {
        title: Lang.t('removable.device'),
        dataIndex: 'deviceId',
        width: 150,
        render: (deviceId: string) => (
          <Tooltip title={deviceId}>
            <div style={{ 
              fontSize: 12,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}>
              {deviceId}
            </div>
          </Tooltip>
        ),
      },
      {
        title: Lang.t('removable.operation'),
        dataIndex: 'operation',
        width: 120,
        render: (operation: string, log: RemovableOperationLog) => {
          const tag = log.getOperationTag();
          return (
            <div>
              <Tag color={tag.color}>{tag.text}</Tag>
              <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>
                {log.getOperationDescription()}
              </div>
            </div>
          );
        },
      },
      {
        title: Lang.t('removable.filePath'),
        dataIndex: 'filePath',
        ellipsis: true,
        render: (filePath: string) => (
          <Tooltip title={filePath}>
            <div style={{ 
              maxWidth: 200, 
              overflow: 'hidden', 
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}>
              {filePath || '--'}
            </div>
          </Tooltip>
        ),
      },
      {
        title: Lang.t('removable.status'),
        dataIndex: 'success',
        width: 100,
        render: (success: boolean, log: RemovableOperationLog) => {
          const tag = log.getSuccessTag();
          return <Tag color={tag.color}>{tag.text}</Tag>;
        },
      },
      {
        title: Lang.t('removable.errorMessage'),
        dataIndex: 'errorMsg',
        width: 200,
        render: (errorMsg: string) => (
          <div style={{ 
            color: errorMsg ? '#ff4d4f' : '#52c41a',
            fontSize: 12,
            maxWidth: 200,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}>
            {errorMsg || Lang.t('common.noError')}
          </div>
        ),
      },
    ];

    return (
      <div className="page-removable-logs">
        <div className="page-title">
          <div className="page-title-name">
            <h2>
              <HistoryOutlined style={{ marginRight: 8 }} />
              {Lang.t('removable.operationLogs')}
            </h2>
            <div className="page-title-desc">
              {Lang.t('removable.operationLogsDesc')}
            </div>
          </div>
          
          <div className="page-title-action">
            <AntdSpace>
              <Button
                type="default"
                onClick={() => this.props.history.push('/removable/list')}
              >
                {Lang.t('removable.backToList')}
              </Button>
              <Button
                type="primary"
                icon={<ReloadOutlined />}
                onClick={this.refresh}
                loading={this.pager.loading}
              >
                {Lang.t('refresh')}
              </Button>
            </AntdSpace>
          </div>
        </div>

        {this.renderSearchToolbar()}

        <Card>
          <Table<RemovableOperationLog>
            rowKey="uuid"
            loading={this.pager.loading}
            dataSource={this.pager.data || []}
            columns={columns}
            pagination={this.pager.getPagination()}
            onChange={this.pager.tableOnChange.bind(this.pager)}
            locale={{
              emptyText: (
                <TableEmpty pager={this.pager} onRefresh={this.refresh.bind(this)} />
              ),
            }}
            scroll={{ x: 1200 }}
          />
        </Card>
      </div>
    );
  }
}